import {
  MOBILE_LAYOUT_BREAKPOINT,
  NODE_HEIGHT,
  NODE_WIDTH
} from './constants.js';

export function fitNodesToViewport(nodes, width, height, margin = 80) {
  if (nodes.length === 0) return { x: 40, y: 40, scale: 1 };

  const bounds = graphBounds(nodes);
  const availableWidth = Math.max(width - (margin * 2), NODE_WIDTH);
  const availableHeight = Math.max(height - (margin * 2), NODE_HEIGHT);
  const scale = Math.min(
    1,
    availableWidth / bounds.width,
    availableHeight / bounds.height
  );
  const safeScale = Number.isFinite(scale) && scale > 0 ? scale : 1;

  return {
    x: ((width - (bounds.width * safeScale)) / 2) - (bounds.minX * safeScale),
    y: ((height - (bounds.height * safeScale)) / 2) - (bounds.minY * safeScale),
    scale: safeScale
  };
}

export function layoutNodesForViewport(nodes, width, height) {
  if (width >= MOBILE_LAYOUT_BREAKPOINT) return nodes;

  const centerX = Math.max(width / 2, 120);
  const top = 72;
  const bottom = Math.max(height - 72, top + 96);
  const gap = nodes.length > 1 ? Math.max(96, Math.min(128, (bottom - top) / (nodes.length - 1))) : 0;

  return nodes.map((node, index) => ({
    ...node,
    x: centerX,
    y: top + (index * gap)
  }));
}

export function diagramHeightForViewport(nodes, width, height) {
  if (width >= MOBILE_LAYOUT_BREAKPOINT) return height;

  return Math.max(height, 160 + ((Math.max(nodes.length, 1) - 1) * 112));
}

export function measureWrapper(wrapper) {
  const rect = wrapper.getBoundingClientRect();
  const measuredWidth = rect.width || wrapper.clientWidth || 0;
  const measuredHeight = rect.height || wrapper.clientHeight || 0;
  const measured = measuredWidth > 0 && measuredHeight > 0;

  return {
    width: measuredWidth || 960,
    height: measuredHeight || 500,
    measured
  };
}

function graphBounds(nodes) {
  const minX = Math.min(...nodes.map(node => node.x - (NODE_WIDTH / 2)));
  const maxX = Math.max(...nodes.map(node => node.x + (NODE_WIDTH / 2)));
  const minY = Math.min(...nodes.map(node => node.y - (NODE_HEIGHT / 2)));
  const maxY = Math.max(...nodes.map(node => node.y + (NODE_HEIGHT / 2)));

  return {
    minX,
    maxX,
    minY,
    maxY,
    width: Math.max(maxX - minX, NODE_WIDTH),
    height: Math.max(maxY - minY, NODE_HEIGHT)
  };
}
